import { Injectable } from '@angular/core';

import { PressKit } from '@modules/content-api/adapter/press-kit.adapter';

import { RichSnippetAdapter, RichSnippet } from '../interface/rich-snippet.interface';

import { BaseRichSnippetAdapter } from './base-rich-snippet.adapter';

@Injectable({
  providedIn: 'root',
})
export class PresskitArticleAdapter extends BaseRichSnippetAdapter implements RichSnippetAdapter {
  adapt(data: PressKit): RichSnippet {
    const imageId =
      data.mainImage?.original?.id || (data.images && data.images.length > 0 ? data.images[0].id : undefined);
    const langCodes = this.extractLanguageCodes(data);

    return {
      '@context': 'https://schema.org',
      '@type': 'Presskit',
      headline: this.truncateHeadline(data.title),
      description: this.extractDescription(data.content),
      articleBody: this.stripHtml(data.content),
      thumbnail: this.generateThumbnailsFromImage(imageId),
      availableLanguage: this.mapLanguageCodes(langCodes),
      datePublished: data.displayDate,
      author: this.getDefaultAuthor(),
    };
  }

  private extractLanguageCodes(data: PressKit): string[] {
    if (!data.articles || data.articles.length === 0) {
      return [];
    }

    const allLangs = new Set<string>();
    data.articles.forEach((article) => {
      if (article.slugs && article.slugs.length > 0) {
        article.slugs.forEach((slug: { lang: string; value: string }) => {
          if (slug.lang) {
            allLangs.add(slug.lang);
          }
        });
      }
    });

    return Array.from(allLangs);
  }
}
